import {Never} from 'app/interface';
import {getComponentConfiguration} from 'app/utils/config/index';

export function getConfigByComponentName<T>(name: string): Never<T> {
    const componentElement = document.querySelector(`[data-gem-module-name="${name}"]`);
    if (!componentElement) {
        throw new Error(`${name} element is missing!`);
    }

    const componentConfiguration = getComponentConfiguration<T>(componentElement);
    if (!componentConfiguration) {
        throw new Error(`${name} config is missing!`);
    }

    return componentConfiguration;
}
